import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(
  (theme) => ({
    span: {
      ...theme.mixins.truncateOverflow,
      display: "block",
    },
  }),
  { index: 10 }
);
